import axios from "axios";
import { HTTPLogger } from "logger/HTTPLoggerStatic";
export const EMPTY_SPELLCHECK_RESULT = {
    spellchecked_text: "",
    changes: [],
};
export function spellcheck(request) {
    return axios
        .post("/api/aienhancer/v1/spellcheck", request, {
        timeout: 10000, // 10 seconds timeout
    })
        .then((response) => {
        if (response.status !== 200) {
            const error = {
                status: response.status,
                statusText: response.statusText,
                request: request,
                message: response.statusText
            };
            HTTPLogger.error("Spellcheck API error:", error);
            throw error;
        }
        return response.data;
    })
        .catch((error) => {
        HTTPLogger.error("Spellcheck API call failed:", error);
        throw error;
    });
}
